import type { FC } from 'react';
import { Box, Fab as MuiFab, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';

export type FabProps = {
  /**
   * Handler when the FAB is clicked (tapped).
   */
  onClick: () => void;

  /**
   * Optional tooltip for the FAB.
   */
  tooltip?: string;
};

export const Fab: FC<FabProps> = ({ onClick, tooltip }) => (
  <Box sx={{ position: 'fixed', bottom: 24, right: 24 }}>
    <Tooltip title={tooltip}>
      <MuiFab color="primary" aria-label="add" onClick={onClick}>
        <Add />
      </MuiFab>
    </Tooltip>
  </Box>
);
